{ "id": "baguette-boisaille", "name": "Baguette de Boisaille", "slot": "arme", "set": "aventurier", "tier": 1, "price": 60, "icon": "icons/items/baguette-boisaille", "stats": { "intelligence": 10 } }
